import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Button } from '@/shared/components/Button';
import { colorBlue, colorBackground, colorText } from '@/utils/palette';

const ConfirmDeleteModal = ({ show, onClose, onConfirm }) => (
  <StyledModal show={show} onHide={onClose} centered>
    <div className="modal-content">
      <Icon className="lnr lnr-cross-circle" />
      <Title>Confirmar exclusão</Title>
      <Message>
        Esta ação é irreversível. Tem certeza que deseja excluir este registro?
      </Message>
      <ButtonGroup>
        <Button variant="secondary" onClick={onClose}>Cancelar</Button>
        <Button variant="danger" onClick={onConfirm}>Excluir</Button>
      </ButtonGroup>
    </div>
  </StyledModal>
);

ConfirmDeleteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmDeleteModal;

// ───────────── STYLES ─────────────

const StyledModal = styled(BootstrapModal)`
  .modal-dialog {
    max-width: 400px;
  }

  .modal-content {
    background-color: ${colorBackground};
    border: none;
    padding: 40px 30px;
    text-align: center;
    color: ${colorText};
    border-radius: 4px;
  }
`;

const Icon = styled.span`
  font-size: 28px;
  color: ${colorBlue};
  margin-bottom: 16px;
`;

const Title = styled.h4`
  font-weight: bold;
  margin-bottom: 12px;
`;

const Message = styled.p`
  font-size: 14px;
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;

  button {
    min-width: 90px;
    padding: 6px 16px;
  }
`;
